import { MoneyString } from 'model/Money'
import { RootAppState } from 'store/configureStore'

export const projectNetSalesPriceSelector = (state: RootAppState) =>
  MoneyString(state.project.activeProject?.financial.salesPriceOfItems)

export const projectNetSalesPriceMoneySelector = (state: RootAppState) =>
  state.project.activeProject?.financial.salesPriceOfItems
